export default "__VITE_ASSET__BrvGF7Da__"